import React, { useEffect, useState } from "react";
import usersIcon from "../../media/guestpage/usersIcon.svg";
import charactersIcon from "../../media/guestpage/charactersIcon.svg";
import { GUEST_STATS } from "../../data/guestPageData";
import { getProjectStatus } from "../../api/services/statusService";

const formatCount = (value) =>
    Number(value).toLocaleString("ru-RU");

const HeroStats = () => {
    const [stats, setStats] = useState({
        users: GUEST_STATS.users,
        characters: GUEST_STATS.characters,
    });

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const data = await getProjectStatus();
                if (!cancelled) {
                    setStats({
                        users: data.usersCount,
                        characters: data.charactersCount,
                    });
                }
            } catch {
                // оставляем значения по умолчанию
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <div className="guest-hero__stats" aria-label="Статистика проекта">
            <div className="guest-hero__stat">
                <img src={usersIcon} alt="" aria-hidden="true" />
                <span>{formatCount(stats.users)} Пользователей</span>
            </div>
            <div className="guest-hero__stat">
                <img src={charactersIcon} alt="" aria-hidden="true" />
                <span>{formatCount(stats.characters)} Персонажей</span>
            </div>
        </div>
    );
};

export default HeroStats;
